import Menu from "./components/Menu";
import SupportModal from "./components/SupportModal";
import lazyLoadImages from "./components/lazyLoad";

document.addEventListener("DOMContentLoaded", async () => {
  lazyLoadImages();

  await new Menu().init();

  await handleCartPopup();
  await handleBreadcrumbsScroll();
  await handleAccordions();
  await footerFaqModal();
  await handleShippingTopBar();
  await handleGlobalLoader();

  window.addEventListener("lazy_update", () => {
    lazyLoadImages();
  });

  window.addEventListener("product_hot_reload", () => {
    handleAccordions();
  });
});

const handleCartPopup = async () => {
  const { default: CartPopup } = await import("./components/CartPopup");
  await new CartPopup().init();
};

const handleBreadcrumbsScroll = async () => {
  const breadcrumbs = document.querySelector(".woocommerce-breadcrumb");
  breadcrumbs && (breadcrumbs.scrollLeft = breadcrumbs.scrollWidth);
};

const handleAccordions = async () => {
  const accordions = [...document.querySelectorAll<HTMLElement>(".accordions")];

  if (accordions.length === 0) return;

  const { default: Accordions } = await import("./components/accordions/Accordions");
  accordions.forEach((accordion) => new Accordions(accordion).init());
};

const footerFaqModal = async () => {
  const supportModal = document.querySelector("#contact-form-modal") as HTMLElement;
  supportModal && new SupportModal(supportModal, "#contact-modal").init();
};

const handleShippingTopBar = async () => {
  const shippingTopBar = document.querySelector<HTMLElement>(".shipping-top-bar");
  if (!shippingTopBar) return;

  const { default: ShippingTopBar } = await import("./components/ShippingTopBar");
  new ShippingTopBar(shippingTopBar).init();
};

const handleGlobalLoader = async () => {
  const globalLoader = document.querySelector<HTMLElement>(".global-loader");
  if (!globalLoader) return;

  const { default: GlobalLoader } = await import("./components/GlobalLoader");
  new GlobalLoader(globalLoader).init();
};
